import React from 'react'

import { REPORT } from '../../../../../helpers/constants'

import Style from './style'

const IssueManagementHeader = (props) => {
  const { language } = props

  return <Style>{REPORT.ISSUE_REPORT[language]}</Style>
}

export default IssueManagementHeader
